export default __webpack_public_path__ + "static/Perfect4-77110d643d214a267bf3c2adf9c54882.jpg";